import { useEffect, useState } from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import useUserStore from '@lcsc-ui/store/user';
import Domains from '@lcsc-ui/utils/domains';
import lcMsgTips from '@lcsc-ui/utils/lcMsgTips';
import sendAxios from '@lcsc-ui/utils/request';
import Utils from '@lcsc-ui/utils/Utils';
import { Modal, InputNumber, Spin, message } from 'antd';

import CountdownModel from './components/countdownModel';

import API from '@/asyncApi/home';

export default function BuyGroupProductDialog({ data, isShowBuyGroupProductDialog, setIsShowBuyGroupProductDialog }) {
  const trackZone = useUserStore((state) => state.fromZone);
  const productVO = data?.productVO;
  const groupActivityProductVO = data?.groupActivityProductVO;
  const [total, setTotalMoney] = useState(0);
  const [loading, setLoading] = useState(false);
  const [catInputNum, setCatInputNum] = useState(groupActivityProductVO?.minBuyNumber);

  useEffect(() => {
    const total = (groupActivityProductVO?.minBuyNumber * groupActivityProductVO?.groupPrice).toFixed(2);
    setTotalMoney(total);
    setCatInputNum(groupActivityProductVO?.minBuyNumber);
  }, []);

  const changeNumber = (e) => {
    setCatInputNum(e);
    const total = (e * groupActivityProductVO?.groupPrice).toFixed(2);
    setTotalMoney(total);
  };

  // 跳登录和注册
  const gotoLogin = (type) => {
    const url = Utils.getCasTypeUrl(type);
    window.open(url, '_self');
  };

  const clickCheckGroup = () => {
    if (!catInputNum) {
      message.warning('请填写立推数量！');
      return;
    }
    const productId = groupActivityProductVO?.productId;
    const purchaseNumber = catInputNum;
    setLoading(true);
    sendAxios({
      method: 'GET',
      baseURL: Domains.lcscItemUrl,
      url: `${API.asyncGroupValidatePerfect}?productId=${productId}&purchaseNumber=${purchaseNumber}`,
    })
      .then((res) => {
        if (res.needLogin) {
          gotoLogin();
          return;
        }
        if (res.code === 200) {
          let url = `${Domains.lcscOrderUrl}/member/perfect/group.html?productId=${productId}&purchaseNumber=${purchaseNumber}&trackZone=${trackZone}`;
          if (Utils.getUrlParam('shortLink')) {
            url += `&shortLink=${Utils.getUrlParam('shortLink')}`;
          }
          window.open(url, '_self');
        } else if (res.msg === 'needChooseCusType') {
          lcMsgTips.showConfirmModal({
            title: '需要验证账户类型',
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal
      width="500px"
      title={`立推商品（${productVO?.productName}）`}
      open={isShowBuyGroupProductDialog}
      onCancel={() => setIsShowBuyGroupProductDialog(false)}
      centered
      footer={
        <Spin indicator={<LoadingOutlined spin />} size="small" spinning={loading}>
          <button
            className="w-[97px] h-[28px] text-[#fff] text-[14px] bg-[#0093e6] text-center rounded ml-[20px] hover:opacity-[0.8]"
            onClick={clickCheckGroup}
          >
            {groupActivityProductVO?.recommendLevel === 'B' || groupActivityProductVO?.recommendLevel === 'C'
              ? '我要订货'
              : '购买立推'}
          </button>
        </Spin>
      }
    >
      <div className="w-[434px] h-[119px] rounded-[6px] border-solid border-[#fff188] text-[14px] bg-[#FFFBE6] pl-[16px] pt-[16px]">
        <CountdownModel groupActivityProductVO={groupActivityProductVO} />
      </div>
      <div className="text-center mt-[24px] flex items-center justify-center">
        <span>购买数量：</span>
        <InputNumber
          controls={false}
          size="mini"
          value={catInputNum}
          min={0}
          precision={0}
          maxLength={8}
          className="w-[100px]"
          onChange={changeNumber}
        />
        &nbsp;×&nbsp;<span className="text-[#FF4960]">{groupActivityProductVO?.groupPrice}</span>&nbsp;=&nbsp;
        <span className="text-[#FF4960]">{total}</span>
      </div>
    </Modal>
  );
}
